// extracted by mini-css-extract-plugin
module.exports = {"article":"DetailsViewCardOrderInfo-article-mYlBZ","container":"DetailsViewCardOrderInfo-container-PvToY","content":"DetailsViewCardOrderInfo-content-5ocgM"};